import React, { forwardRef } from 'react';
import MuiLinearProgress, { LinearProgressProps as MuiLinearProgressProps } from '@mui/material/LinearProgress';
import { BpDesignSystem } from '../../types';

export type LinearProgressProps = BpDesignSystem.PropsWithChildren<MuiLinearProgressProps>;

export const LinearProgress = forwardRef<HTMLElement, LinearProgressProps>(({ dataTest, ...rest }, ref) => (
  <MuiLinearProgress color="primary" data-test={dataTest} {...rest} ref={ref} />
));
